export const playbackRates = [10.0, 5.0, 2.0, 1.5, 1.0, 0.7]
